import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("ml-lang") || "pt");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    localStorage.setItem("ml-lang", l);
    setLangState(l);
    document.documentElement.lang = l;
  }, []);

  // t("nav.home") -> string ; can also return arrays/functions
  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) node = node?.[p];
      return node ?? path;
    },
    [lang]
  );

  // ml({pt,en,es}) -> localized value from API content
  const ml = useCallback((field) => field?.[lang] ?? field?.pt ?? "", [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, ml }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
